import React, { useCallback, useState } from "react";
import { useContext } from "react";
import { Async } from "react-async";
import { IListViewItem } from "../components/listView/ListView";
import { Dictionary } from "../config";
import { IHype } from "../pages/hypes/Hypes";
import DataService from "./DataService";
import I18n from "./I18n";
import { Loader } from "../components/Loader/Loader";
export interface IDataType {
  actors: IListViewItem[];
  hypes: IHype[];
  directors: IListViewItem[];
  locale: Dictionary<string>;
}

export interface IDataContext {
  data: IDataType;
  setData: (data: IDataType) => void;
}

const DataContext = React.createContext<IDataContext>({
  data: {
    hypes: [],
    actors: [],
    directors: [],
    locale: {},
  },
  setData: (s) => { }
});

class DataContextModel implements IDataContext {
  data: IDataType;
  setData: (data: IDataType) => void;

  constructor(data: IDataType, setData: (data: IDataType) => void) {
    this.data = data;
    this.setData = setData;
  }
}

export const DataContextProvider: React.FC<any> = (props) => {
  let [data, setData] = useState();
  const initialize = useCallback(async () => {
    let res = await DataService.load();
    I18n.setLang("en");
    I18n.setLocale((res as IDataType).locale)
    setData(res as any);
  }, [
  ]);

  return <Async promiseFn={initialize}>
    <Async.Loading>
      <Loader />
    </Async.Loading>
    <Async.Resolved>
      <DataContext.Provider value={new DataContextModel(data as any, setData as any)}>
        {props.children}
      </DataContext.Provider>
    </Async.Resolved>
  </Async>

};

export function useDataContext() {
  return useContext(DataContext).data;
}

export function useLocale() {
  return useContext(DataContext).data.locale.en;
}
